import React, { useEffect, useMemo, useState, useRef } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { ReactComponent as InfoEye } from "../../assets/icons/info_eye.svg";
import { ReactComponent as CircleWarning } from "../../assets/icons/Circle_Warning.svg";
import { ReactComponent as Tick } from "../../assets/icons/tick.svg";
import { UserOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { ReactComponent as CircleTick } from "../../assets/icons/Circle_Check.svg";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Steps,
  Table,
  Tabs,
} from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import image from "../../assets/icons/employee/employee_1.png";
import { connect, useSelector } from "react-redux";
import {
  getLocations,
  getSupervisorList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import moment from "moment";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { useList } from "react-use";
import { DeleteOutlined } from "@ant-design/icons";

const Styleddiv = styled.div`
  .ant-btn {
    // border: none !important;
    box-shadow: none !important;
  }

  .cancel-previous-button {
    border: 1px solid black;
  }

  .ant-btn:hover,
  .ant-btn:focus,
  .ant-btn:active {
    // border: none !important;
    box-shadow: none !important;
    background: transparent;
  }

  .custom-scrollbar::-webkit-scrollbar {
    width: 6px; /* Thin scrollbar */
  }

  .disabled-tabs .ant-tabs-tab {
    pointer-events: none;
    cursor: not-allowed;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: white; /* White scrollbar thumb */
    border-radius: 3px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: transparent; /* Transparent track */
  }

  /* For Firefox */
  .custom-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: white transparent; /* White thumb, transparent track */
  }

  .total-div {
    display: flex;
  }
  .completed-div {
    width: 16%;
    border-right: 1px solid #e2e2e8;
  }
  .name-div {
    width: 80%;
  }
  .name-info {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e2e2e8;
    padding-bottom: 2px;
    padding-left: 8px;
  }
  .left_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e2e2e8;
    padding-bottom: 2px;
  }
  .name-style {
    font-weight: 500;
    font-size: 18px;
  }
  .completed-line {
    border-bottom: 1px solid #e2e2e8;
    padding-bottom: 5px;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: black !important;
    font-size: 14px;
  }
  .ant-tabs-ink-bar {
    background-color: black !important;
  }
  .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: black !important;
  }
  .tab-modal {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 8px;
    height: calc(100vh - 300px);
    overflow-y: auto;
  }
  .heading-text {
    font-weight: 500;
    font-size: 16px;
    padding-bottom: 20px;
    padding-top: 20px;
  }
  .tab-description {
    display: flex;
    justify-content: space-between;
    margin-right: 10px;
  }
  .employee-info {
    font-weight: 400;
    font-size: 14px;
    color: #126df6;
    cursor: pointer;
    margin-left: 20px;
  }
  .view-job-description {
    font-weight: 400;
    font-size: 14px;
    text-decoration: underline;
    color: #126df6;
    cursor: pointer;
    margin-left: "20px";
  }
  .prev-arrow {
    text-decoration: underline;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
  }
  .next-arrow {
    text-decoration: underline;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
  }
  .next-arrow-active {
    color: #1f243b;
  }
  .next-arrow-disabled {
    color: rgb(145, 146, 151);
    cursor: not-allowed;
  }
  .tabs_actions_container {
    width: 100%;
    display: flex;
    gap: 1.5rem;
    justify-content: end;
    align-items: center;
  }
  .cancel-create-button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: calc(100% - 301px); /* Adjust width dynamically */
    background-color: white;
    margin-left: 301px;
    display: flex;
    justify-content: end;
    gap: 24px;
    padding: 24px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }
  .cancel-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #1f243b;
    font-weight: 400;
    font-size: 16px;
    color: #1f243b;
  }
  .create-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #c2fae5;
    border: #c2fae5;
    font-weight: 400;
    font-size: 16px;
  }
  .create-button-disabled {
    color: rgb(145, 146, 151) !important;
    cursor: not-allowed;
    opacity: 0.6;
  }
  .create-button-enabled {
    color: #1f243b !important;
    cursor: pointer;
  }
  .vertical_step .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: unset !important;
  }
  .vertical_step.ant-steps-vertical > .ant-steps-item .ant-steps-item-icon {
    float: right !important;
    margin-right: 0px !important;
  }
  .vertical_step.ant-steps-vertical > .ant-steps-item .ant-steps-item-content {
    height: auto !important;
  }

  .ant-steps-vertical > .ant-steps-item .ant-steps-item-content {
    display: block;
    min-height: 0px !important;
    overflow: hidden;
    .step_name_container {
      height: calc(100vh - 300px);
      overflow-y: auto;
    }
  }

  .employee-count {
    font-weight: 500;
    font-size: 18px;
  }

  .employee-name {
    font-weight: 500;
    font-size: 18px;
  }

  .ant-steps-vertical {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    max-height: 400px;
  }
`;
const StyledModal = styled(Modal)`
  .modal-title {
    font-weight: 600;
    font-size: 18px;
  }
  .role-title {
    font-weight: 400;
    font-size: 16px;
  }
  .ant-modal-content {
    border-radius: 8px !important;
    padding: 24px;
  }
  .ant-modal-footer {
    border-top: none !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  .cancel-modal-button {
    width: 83px;
    height: 34px;
    border: none;
    font-weight: 400;
    font-size: 16px;
  }
  .discard-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #1f243b;
    font-weight: 400;
    font-size: 16px;
  }
  .save-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #c2fae5;
    font-weight: 400;
    font-size: 16px;
  }
  .modal-text {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
    margin-bottom: 0;
  }
  .circle-warning-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .tick-created {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .created-text {
    font-weight: 400;
    font-size: 18px;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: black !important;
  }
  .ant-tabs-ink-bar {
    background-color: black !important;
  }
  .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: black !important;
  }
`;
const StyledSpan = styled.span`
  color: #636980;
  font-size: 14px;
  font-weight: 400;
`;

const Sectiontitle = styled.section`
  font-weight: 500;
  font-size: 16px;
  padding-bottom: 10px;
`;

const { Step } = Steps;

const CreatingPerformance = ({
  isEditing,
  setEditPerformance = () => {},
  overAllAppraiseeData,
  editAppraiseeData,
  editoverAllAppraiseeData,
  formData,
  editingformData,
  getEmployeeList,
  setStep,
  isDraft,
  setIsDraft,
  isCancelModal,
  setIsCancelModal,
}) => {
  const history = useHistory();
  const [isJobDescription, setIsJobDescription] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [isCancelModal, setIsCancelModal] = useState(false);
  // const [stepData, setStepData] = useState({});
  const [updatedData, setUpdatedData] = useState(
    editAppraiseeData[0]?.individual_appraisals
  );

  const [loading, setLoading] = useState(false);
  const [draftStatus, setDraftStatus] = useState(false);

  const [stepData, setStepData] = useState(
    isEditing ? updateData(editAppraiseeData[0]?.individual_appraisals) : {}
  );
  const [isCreatedModalVisible, setIsCreatedModalVisible] = useState(false);
  const userInfo = useSelector(getUserInfo);
  const userList = useSelector(getUserList);
  const [current, setCurrent] = useState(0);
  let initialEditAppraiseeData =
    editAppraiseeData[0]?.individual_appraisals?.map((employee) => {
      return {
        emailid: employee?.apraiseemailid,
        name: employee?.apraiseename,
        tabs: employee?.appraiseeroletype,
      };
    }) || [];

  // Extract email IDs from initialEditAppraiseeData to exclude
  let excludeEmails = new Set(
    initialEditAppraiseeData?.map((item) => item.emailid)
  );
  const draftAppraiseeData = Object.values(
    editAppraiseeData?.[0]?.individual_appraisals || {}
  )
    .filter((employee) => {
      const completedTab = employee?.completedTab || {};
      // Check if any value in completedTab is false
      return Object.values(completedTab).some((value) => value === true);
    })
    .map((employee) => ({
      emailid: employee.apraiseemailid,
      name: employee.apraiseename,
      tabs: employee.appraiseeroletype,
    }));

  // Extract email IDs from initialEditAppraiseeData to exclude

  // Filter editoverAllAppraiseeData to keep only those not in initialEditAppraiseeData
  let filteredOverAllAppraiseeData =
    editoverAllAppraiseeData
      ?.filter((item) => !excludeEmails.has(item.userid))
      ?.map((item) => ({
        emailid: item?.userid,
        name: item?.fullname,
        tabs: item?.appraisalInformation
          ?.filter((item) => item.appraisal?.toLowerCase() === "yes")
          ?.map((info) => info.roletype),
      })) || [];

  let filteredEditAppraiseeData = [
    ...initialEditAppraiseeData,
    ...filteredOverAllAppraiseeData,
  ];

  const [selectedName, setSelectedName] = useState(
    isEditing
      ? filteredEditAppraiseeData?.[0]?.name
      : overAllAppraiseeData?.[0]?.fullname || null
  );

  const locationList = useSelector(getLocations);

  const locationIds = [
    ...new Set(overAllAppraiseeData?.map((item) => item.levellocationid)),
  ];

  const filterLocations = locationIds
    .map((id) => locationList?.find((location) => location.location_id === id))
    .filter(Boolean);
  const editCompletedEmployees = initialEditAppraiseeData?.map(
    (emp) => emp.name
  );

  useEffect(() => {
    if (isEditing) {
      setCompletedEmployees(editCompletedEmployees);
    }
  }, [editAppraiseeData, isEditing]);

  function updateData(apiData) {
    return apiData?.reduce((acc, user) => {
      const {
        id,
        apraiseename,
        apraiseemailid,
        upcomingappraisalperiod,
        technicalassessment,
        appraisarmailid,
        appraiseeroletype,
      } = user;

      acc[apraiseemailid] = {
        ...acc[apraiseemailid], // Preserve previous values if they exist
        upcoming_appraisal_period: {
          ...acc[apraiseemailid]?.upcoming_appraisal_period,
          ...upcomingappraisalperiod, // Update from API
        },
        technical_assessment: {
          ...acc[apraiseemailid]?.technical_assessment,
          ...technicalassessment,
        },
        completedTab: Object.fromEntries(
          Object.keys(upcomingappraisalperiod || {}).map((_, index) => [
            index + 1,
            false,
          ])
        ),
        appraisarmailid: appraisarmailid || [],
        appraiseeroletype: appraiseeroletype || [],
        apraiseename: apraiseename || "",
        apraiseemailid: apraiseemailid || "",
      };

      return acc;
    }, {});
  }

  useEffect(() => {
    if (
      current <= isEditing
        ? filteredEditAppraiseeData?.length - 1
        : overAllAppraiseeData?.length - 1
    ) {
      setSelectedName(
        isEditing
          ? filteredEditAppraiseeData?.[current]?.name
          : overAllAppraiseeData?.[current]?.fullname || null
      );
    }
  }, [current]);

  const selectedEmployee = isEditing
    ? userList?.find((emp) => emp.fullname === selectedName)
    : overAllAppraiseeData?.find((emp) => emp.fullname === selectedName) || {};

  const filterLevelLocationName = locationList?.find(
    (item) => item.location_id === selectedEmployee?.levellocationid
  );

  const showJob = () => {
    setIsJobDescription(true);
  };
  const handleCancel = () => {
    setIsJobDescription(false);
  };
  const showModal = () => setIsModalVisible(true);
  const handleCancelModal = () => setIsModalVisible(false);

  const onChangeEmp = (key) => {
    // console.log(key);
  };
  const showCancelModal = () => {
    setIsCancelModal(true);
    setEditPerformance(false);
  };
  const handleModalCancel = () => {
    setIsCancelModal(false);
  };
  const handleDiscard = () => {
    form.resetFields();
    if (typeof setEditPerformance === "function") {
      setEditPerformance(false);
    }
    setIsDraft(false);
    setIsCancelModal(false);
    history.push(`/performancemanagement`, { tabId: "2" });
  };

  const showCreatedModal = () => {
    setIsCreatedModalVisible(true);
    setTimeout(() => {
      setIsCreatedModalVisible(false);
      history.push("/performancemanagement");
    }, 2000);
  };
  const handleCreatedModalClose = () => {
    setIsCreatedModalVisible(false);
    history.push("/performancemanagement");
  };

  const appraisalcolumns = [
    {
      title: "Org Level",
      dataIndex: "orgLevel",
      render: (text) => text || "---",
    },
    {
      title: "Area of Work",
      dataIndex: "areaofwork",
      render: (text) => text || "---",
    },
    {
      title: "Sub Area of Work",
      dataIndex: "subareaofwork",
      render: (text) => text || "---",
    },
    {
      title: "Role Level",
      dataIndex: "rolelevel",
      render: (text) => text || "---",
    },
    {
      title: "Appraiser",
      dataIndex: "appraiser",
      render: (text) => text || "---",
    },
    {
      title: "Weightage (%)",
      dataIndex: "weightage",
      render: (text) => `${text}%` || "---",
    },
    {
      title: "Role Type",
      dataIndex: "roletype",
      render: (text) => text || "---",
    },
    {
      title: "Appraisal",
      dataIndex: "appraisal",
      render: (text) => text || "---",
    },
  ];

  const educationcolumns = [
    { title: "Level", dataIndex: "awarded", render: (text) => text || "---" },
    {
      title: "Qualification",
      dataIndex: "qualification",
      render: (text) => text || "---",
    },
    {
      title: "Institute / University",
      dataIndex: "institutename",
      render: (text) => text || "---",
    },
    {
      title: "Status",
      dataIndex: "educationStatus",
      render: (text) => text || "---",
    },
    { title: "Year", dataIndex: "year", render: (text) => text || "---" },
    {
      title: "Star University",
      dataIndex: "starUniversity",
      render: (text) => text || "---",
    },
    {
      title: "Classificaton",
      dataIndex: "classification",
      render: (text) => text || "---",
    },
  ];

  const appraisalitems = [
    {
      key: "1",
      label: "Appraisal Info",
      children: (
        <Table
          dataSource={selectedEmployee?.appraisalInformation}
          columns={appraisalcolumns}
          pagination={false}
          rowKey="key"
        />
      ),
    },
    {
      key: "2",
      label: "Education",
      children: (
        <Table
          dataSource={selectedEmployee?.educationdetails}
          columns={educationcolumns}
          pagination={false}
          rowKey="key"
        />
      ),
    },
  ];

  const [data, setData] = useState();

  const weightageSources = [
    {
      sno: "1",
      objectives: "Key responsibilities (from job descriptions)",
    },
    {
      sno: "2",
      objectives: "Additional Roles / Backstopping Roles",
    },
    {
      sno: "3",
      objectives: "Strategic / Target objectives",
    },
    {
      sno: "4",
      objectives: "Actions expected from previous Appraisal",
    },
  ];

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const transformedEmployees = isEditing
    ? filteredEditAppraiseeData
    : overAllAppraiseeData?.map((employee) => {
        return {
          emailid: employee?.userid,
          name: employee?.fullname,
          tabs: employee?.appraisalInformation
            ?.filter((info) => info.appraisal === "Yes")
            ?.map((info) => info.roletype),
        };
      });

  const [employeesState, setEmployeesState] = useState([]);

  useEffect(() => {
    if (!transformedEmployees) return;

    setEmployeesState(
      transformedEmployees.map((employee) => {
        const isMatched =
          isEditing && editCompletedEmployees?.includes(employee?.name);

        return {
          emailid: employee?.emailid,
          name: employee?.name,
          tabs: employee?.tabs?.reduce((acc, tab) => {
            acc[tab] = isMatched ? true : false;
            return acc;
          }, {}),
        };
      })
    );
  }, []);

  const [form] = Form.useForm();
  const [activeEmployeeIndex, setActiveEmployeeIndex] = useState(0);
  const [completedEmployees, setCompletedEmployees] = useState([]);
  const [activeTab, setActiveTab] = useState(
    transformedEmployees?.[0]?.tabs?.[0]
  );
  const [tabId, setTabId] = useState(1);
  const [employeeData, setEmployeeData] = useState({});
  const [keyResponsibilitiesData, setKeyResponsibilitiesData] = useState([
    { sno: "1", targetobjective: "", expectedoutcomes: "", targetdate: null },
  ]);
  const [weightageSource, setWeightageSource] = useState(weightageSources);
  const [completedTabs, setCompletedTabs] = useState(false);

  useEffect(() => {
    setSelectedName(transformedEmployees?.[activeEmployeeIndex]?.name);
  }, [activeEmployeeIndex]);

  const handleAddRow = () => {
    if (keyResponsibilitiesData.length < 10) {
      setKeyResponsibilitiesData([
        ...keyResponsibilitiesData,
        {
          sno: (keyResponsibilitiesData.length + 1).toString(),
          targetobjective: "",
          expectedoutcomes: "",
          targetdate: null,
        },
      ]);
    }
  };

  const handleDeleteRow = (key) => {
    if (keyResponsibilitiesData?.length > 1) {
      const updatedKeyResponsibilities = keyResponsibilitiesData.filter(
        (row) => row.sno !== key
      );
      setKeyResponsibilitiesData(updatedKeyResponsibilities);

      const updated = updatedData.map((item) => {
        const newItem = { ...item };
        if (
          newItem.upcomingappraisalperiod &&
          newItem.upcomingappraisalperiod[activeTab]
        ) {
          newItem.upcomingappraisalperiod[activeTab] =
            newItem.upcomingappraisalperiod[activeTab].filter(
              (row) => row.sno !== key
            );
        }
        return newItem;
      });

      setUpdatedData(updated);
    }
  };

  useEffect(() => {
    const currentEmployee = transformedEmployees[activeEmployeeIndex];
    const userid = currentEmployee?.emailid;

    if (stepData[userid] && stepData[userid][activeTab]) {
      form.setFieldsValue(stepData[userid][activeTab]);
    } else {
      form.resetFields();
    }
  }, [activeTab, activeEmployeeIndex]);

  const handleFormChange = async (allValues) => {
    const values = allValues;
    const updatedKeyResponsibilitiesData = keyResponsibilitiesData.map(
      (row) => ({
        ...row,
        targetobjective:
          values[`targetObjective${activeTab}`]?.[row.sno]?.targetobjective ||
          row.targetobjective,
        expectedoutcomes:
          values[`expectedoutcomes${activeTab}`]?.[row.sno]?.expectedoutcomes ||
          row.expectedoutcomes,
        targetdate:
          values[`targetdate${activeTab}`]?.[row.sno]?.targetdate ||
          row.targetdate,
      })
    );

    setKeyResponsibilitiesData(updatedKeyResponsibilitiesData);
    const currentTabs = transformedEmployees[activeEmployeeIndex]?.tabs || [];
    const currentTabIndex = currentTabs.indexOf(activeTab);
    if (currentTabIndex === -1) return;

    const status = currentTabs[currentTabIndex];
    setTabId(currentTabIndex + 1);

    setUpdatedData((prevData) => {
      let updatedData = Array.isArray(prevData) ? [...prevData] : [];

      if (!updatedData[activeEmployeeIndex]) {
        updatedData[activeEmployeeIndex] = {
          upcomingappraisalperiod: {},
          technicalassessment: {},
          completedTab: {},
          appraisarmailid: [],
          appraiseeroletype: [],
          apraiseename: "",
        };
      }

      const existingData =
        updatedData[activeEmployeeIndex]?.upcomingappraisalperiod?.[status] ||
        [];

      const targetObjective = values[`targetObjective${activeTab}`] || {};
      const expectedOutcomes = values[`expectedoutcomes${activeTab}`] || {};
      const targetDates = values[`targetdate${activeTab}`] || {};
      const weightage = values[`weightage${activeTab}`] || {};

      const newFormattedData =
        keyResponsibilitiesData?.map(({ sno }) => ({
          sno: parseInt(sno, 10),
          targetobjective: targetObjective[sno]?.targetobjective || "",
          expectedoutcomes: expectedOutcomes[sno]?.expectedoutcomes || "",
          targetdate: targetDates[sno]?.targetdate
            ? new Date(targetDates[sno].targetdate).toISOString().split("T")[0]
            : "",
        })) || [];

      const newTechnicalAssessment =
        weightageSource?.map(({ sno, objectives }) => ({
          sno: parseInt(sno, 10),
          objectives,
          weightage: weightage[sno]?.weightage || "",
        })) || [];

      const mergedData = [
        ...existingData.filter(
          (existing) =>
            !newFormattedData.some((newItem) => newItem.sno === existing.sno)
        ),
        ...newFormattedData,
      ];

      const mergedTechnicalAssessment = [
        ...(
          updatedData[activeEmployeeIndex]?.technicalassessment?.[status] || []
        ).filter(
          (existing) =>
            !newTechnicalAssessment.some(
              (newItem) => newItem.sno === existing.sno
            )
        ),
        ...newTechnicalAssessment,
      ];

      updatedData[activeEmployeeIndex] = {
        ...updatedData[activeEmployeeIndex],
        upcomingappraisalperiod: {
          ...updatedData[activeEmployeeIndex]?.upcomingappraisalperiod,
          [status]: mergedData,
        },
        technicalassessment: {
          ...updatedData[activeEmployeeIndex]?.technicalassessment,
          [status]: mergedTechnicalAssessment,
        },
      };

      return updatedData;
    });
  };
  useEffect(() => {
    if (updatedData && activeEmployeeIndex >= 0) {
      const upcomingappraisalperiodTabData =
        updatedData[activeEmployeeIndex]?.upcomingappraisalperiod?.[activeTab];

      const technicalassessmentTabData =
        updatedData[activeEmployeeIndex]?.technicalassessment?.[activeTab];

      setWeightageSource(technicalassessmentTabData || weightageSources);

      if (Array.isArray(upcomingappraisalperiodTabData)) {
        setKeyResponsibilitiesData(upcomingappraisalperiodTabData); // Create a new array reference
      } else {
        setKeyResponsibilitiesData([
          {
            sno: "1",
            targetobjective: "",
            expectedoutcomes: "",
            targetdate: null,
          },
        ]);
      }
    }
  }, [editAppraiseeData, activeEmployeeIndex, activeTab]);

  const handleNext = async () => {
    try {
      await form.validateFields();
      if (!validateTotalWeightage()) return;
      const values = form.getFieldsValue();
      const currentTabs = transformedEmployees[activeEmployeeIndex].tabs;
      const currentTabIndex = currentTabs.indexOf(activeTab);
      const currentEmployee = transformedEmployees[activeEmployeeIndex];
      const userid = currentEmployee.emailid; // Assuming `email` exists

      // Dynamically create status based on activeTab
      const status = currentTabs[currentTabIndex];

      setTabId(currentTabIndex + 1);

      setEmployeeData((prevData) => ({
        ...prevData,
        [`${activeEmployeeIndex}-${activeTab}`]: form.getFieldsValue(),
      }));

      const findusername = userList?.find((item) => item?.userid === userid);

      setUpdatedData((prevData) => {
        // Ensure prevData is initialized as an array
        let updatedData = Array.isArray(prevData) ? [...prevData] : [];

        // Check if there's an existing entry at the `activeEmployeeIndex` index
        if (!updatedData[activeEmployeeIndex]) {
          updatedData[activeEmployeeIndex] = {
            upcomingappraisalperiod: {},
            technicalassessment: {},
            completedTab: {},
            appraisarmailid: [],
            appraiseeroletype: [],
            apraiseename: "",
          };
        }

        const existingData =
          updatedData[activeEmployeeIndex]?.upcomingappraisalperiod?.[status] ||
          [];

        const targetObjective = values[`targetObjective${activeTab}`] || {};
        const expectedOutcomes = values[`expectedoutcomes${activeTab}`] || {};
        const targetDates = values[`targetdate${activeTab}`] || {};
        const weightage = values[`weightage${activeTab}`] || {};

        const newFormattedData = keyResponsibilitiesData?.map(({ sno }) => ({
          sno: parseInt(sno, 10),
          targetobjective: targetObjective[sno]?.targetobjective || "",
          expectedoutcomes: expectedOutcomes[sno]?.expectedoutcomes || "",
          targetdate: targetDates[sno]?.targetdate
            ? new Date(targetDates[sno].targetdate).toISOString().split("T")[0]
            : "",
        }));

        const newTechnicalAssessment = weightageSource.map(
          ({ sno, objectives }) => ({
            sno: parseInt(sno),
            objectives: objectives,
            weightage: weightage[sno]?.weightage || "",
          })
        );

        const mergedData = [
          ...existingData.filter(
            (existing) =>
              !newFormattedData.some((newItem) => newItem.sno === existing.sno)
          ),
          ...newFormattedData,
        ];

        const mergedTechnicalAssessment = [
          ...(
            updatedData[activeEmployeeIndex]?.technicalassessment?.[status] ||
            []
          ).filter(
            (existing) =>
              !newTechnicalAssessment.some(
                (newItem) => newItem.sno === existing.sno
              )
          ),
          ...newTechnicalAssessment,
        ];

        updatedData[activeEmployeeIndex] = {
          ...updatedData[activeEmployeeIndex],
          upcomingappraisalperiod: {
            ...updatedData[activeEmployeeIndex]?.upcomingappraisalperiod,
            [status]: mergedData,
          },
          technicalassessment: {
            ...updatedData[activeEmployeeIndex]?.technicalassessment,
            [status]: mergedTechnicalAssessment,
          },
          completedTab: {
            ...(updatedData[activeEmployeeIndex]?.completedTab || {}),
            [status]: true,
          },
          appraisarmailid:
            userList
              ?.filter((user) => user?.userid === userid)
              ?.flatMap((user) => user?.appraisalInformation)
              ?.filter((info) => info?.appraisal?.toLowerCase() === "yes")
              ?.map((info) => info?.appraiser) || [],
          appraiseeroletype:
            userList
              ?.filter((user) => user?.userid === userid)
              ?.flatMap((user) => user?.appraisalInformation)
              ?.filter((info) => info?.appraisal?.toLowerCase() === "yes")
              ?.map((info) => info?.roletype) || [],
          apraiseename: findusername?.fullname || "",
        };

        return updatedData;
      });

      setStepData((prevData) => {
        const existingData =
          prevData[userid]?.upcoming_appraisal_period?.[status] || [];

        const targetObjectives = values[`targetObjective${activeTab}`] || {};
        const expectedOutcomes = values[`expectedoutcomes${activeTab}`] || {};
        const targetDates = values[`targetdate${activeTab}`] || {};
        const weightage = values[`weightage${activeTab}`] || {};

        const newFormattedData = keyResponsibilitiesData?.map(({ sno }) => ({
          sno: parseInt(sno, 10),
          targetobjective: targetObjectives[sno]?.targetobjective || "",
          expectedoutcomes: expectedOutcomes[sno]?.expectedoutcomes || "",
          targetdate: targetDates[sno]?.targetdate
            ? new Date(targetDates[sno].targetdate).toISOString().split("T")[0]
            : "",
        }));

        const newTechnicalAssessment = weightageSource.map(
          ({ sno, objectives }) => ({
            sno: parseInt(sno, 10),
            objectives: objectives,
            weightage: weightage[sno]?.weightage || "",
          })
        );

        const mergedData = [
          ...existingData.filter(
            (existing) =>
              !newFormattedData.some((newItem) => newItem.sno === existing.sno)
          ),
          ...newFormattedData,
        ];

        const mergedTechnicalAssessment = [
          ...(prevData[userid]?.technical_assessment?.[status] || []).filter(
            (existing) =>
              !newTechnicalAssessment.some(
                (newItem) => newItem.sno === existing.sno
              )
          ),
          ...newTechnicalAssessment,
        ];

        return {
          ...prevData,
          [userid]: {
            ...prevData[userid],
            upcoming_appraisal_period: {
              ...prevData[userid]?.upcoming_appraisal_period,
              [status]: mergedData,
            },
            technical_assessment: {
              ...prevData[userid]?.technical_assessment,
              [status]: mergedTechnicalAssessment,
            },
            completedTab: {
              ...Object.fromEntries(
                Object.entries(prevData[userid]?.completedTab || {}).filter(
                  ([key]) => isNaN(key)
                )
              ),
              [status]: true,
            },

            appraisarmailid:
              userList
                ?.filter((user) => user.userid === userid)
                ?.flatMap((user) => user?.appraisalInformation)
                ?.filter((info) => info.appraisal === "Yes")
                ?.map((info) => info?.appraiser) || [],
            appraiseeroletype:
              userList
                ?.filter((user) => user.userid === userid)
                ?.flatMap((user) => user?.appraisalInformation)
                ?.filter((info) => info.appraisal === "Yes")
                ?.map((info) => info?.roletype) ||
              []
                ?.flatMap((user) => user?.appraisalInformation)
                ?.filter((info) => info.appraisal === "Yes")
                ?.map((info) => info?.roletype) ||
              [],
            apraiseename: findusername?.fullname || "",
          },
        };
      });

      setEmployeesState((prevState) =>
        prevState.map((employee, empIndex) => {
          if (empIndex === activeEmployeeIndex) {
            return {
              ...employee,
              tabs: {
                ...employee.tabs,
                [activeTab]: true, // Update the current tab to true
              },
            };
          }
          return employee;
        })
      );

      if (currentTabIndex < currentTabs.length - 1) {
        setActiveTab(currentTabs[currentTabIndex + 1]);
      } else {
        if (
          !completedEmployees.includes(
            transformedEmployees[activeEmployeeIndex]?.name
          )
        ) {
          setCompletedEmployees([
            ...completedEmployees,
            transformedEmployees[activeEmployeeIndex]?.name,
          ]);
        }

        if (activeEmployeeIndex < transformedEmployees.length - 1) {
          setActiveEmployeeIndex((prev) => prev + 1);
          setActiveTab(transformedEmployees[activeEmployeeIndex + 1].tabs[0]);
        }
      }
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      await handleNext();
      setIsSubmitting(true);
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      message.error("Failed to submit the Performance Contract.");
    }
  };

  const handleSaveAndExit = async () => {
    setIsSubmitting(true);
    setIsCancelModal(false);
  };

  const locationMap = Object.fromEntries(
    locationList.map((loc) => [loc.location_id, loc.location_name])
  );

  useEffect(() => {
    if (isSubmitting) {
      setLoading(true);
      const submitData = async () => {
        const emailIds = Object.keys(stepData);

        const employeeIds = overAllAppraiseeData
          ?.filter((item) => !emailIds.includes(item.userid))
          .map((item) => item.userid);

        // Clone stepData and add missing entries for employeeIds
        const updatedStepData = {
          ...stepData,
          ...employeeIds?.reduce((acc, id) => {
            const user = overAllAppraiseeData.find((val) => val.userid === id);

            const upcomingAppraisalPeriod = user?.appraisalInformation
              ?.filter((info) => info.appraisal === "Yes")
              ?.reduce((periods, item, index) => {
                periods[item.roletype] = [
                  {
                    sno: 1,
                    targetobjective: "",
                    expectedoutcomes: "",
                    targetdate: "",
                  },
                ];
                return periods;
              }, {});

            const technicalAssessment = user?.appraisalInformation
              ?.filter((info) => info.appraisal === "Yes")
              ?.reduce((assessment, item) => {
                assessment[item.roletype] = [
                  {
                    sno: 1,
                    objectives: "Key responsibilities (from job descriptions)",
                    weightage: "",
                  },
                  {
                    sno: 2,
                    objectives: "Additional Roles / Backstopping Roles",
                    weightage: "",
                  },
                  {
                    sno: 3,
                    objectives: "Strategic / Target objectives",
                    weightage: "",
                  },
                  {
                    sno: 4,
                    objectives: "Actions expected from previous Appraisal",
                    weightage: "",
                  },
                ];
                return assessment;
              }, {});

            acc[id] = {
              upcoming_appraisal_period: upcomingAppraisalPeriod || {},
              technical_assessment: technicalAssessment || {},
              completedTab: {},
              appraisarmailid:
                user?.appraisalInformation
                  ?.filter((info) => info.appraisal === "Yes")
                  ?.map((info) => info.appraiser) || [],
              appraiseeroletype:
                user?.appraisalInformation
                  ?.filter((info) => info.appraisal === "Yes")
                  ?.map((info) => info.roletype) || [],
              apraiseename: user?.fullname || "",
              apraiseemailid: id,
            };

            return acc;
          }, {}),
        };

        const obj = {
          contractstatus: draftStatus ? "draft" : "completed",
          performancecontractname: isEditing
            ? editingformData?.contractName
            : formData?.contractName,
          type: isEditing ? editingformData?.type : formData?.type,
          submissionstartdate: isEditing
            ? editingformData?.startDate
            : formData?.startDate,
          submissionenddate: isEditing
            ? editingformData?.endDate
            : formData?.endDate,
          agreestatus: "",
          country: isEditing
            ? [
                ...new Set(
                  editoverAllAppraiseeData.flatMap(
                    (data) => data.managingoffice
                  )
                ),
              ]
            : [
                ...new Set(
                  overAllAppraiseeData.flatMap((data) => data.managingoffice)
                ),
              ],
          competency: isEditing
            ? [
                ...new Set(
                  editoverAllAppraiseeData.flatMap((data) => data.competencyQC)
                ),
              ]
            : [
                ...new Set(
                  overAllAppraiseeData.flatMap((data) => data.competencyQC)
                ),
              ],
          serviceline: isEditing
            ? [
                ...new Set(
                  editoverAllAppraiseeData.flatMap((data) => data.serviceline)
                ),
              ]
            : [
                ...new Set(
                  overAllAppraiseeData.flatMap((data) => data.serviceline)
                ),
              ],
          subserviceline: isEditing
            ? [
                ...new Set(
                  editoverAllAppraiseeData.flatMap(
                    (data) => data.subserviceline
                  )
                ),
              ]
            : [
                ...new Set(
                  overAllAppraiseeData.flatMap((data) => data.subserviceline)
                ),
              ],
          location: isEditing
            ? [
                ...new Set(
                  editoverAllAppraiseeData
                    .map((data) => locationMap[data.levellocationid])
                    .filter(Boolean)
                ),
              ]
            : [
                ...new Set(
                  filterLocations.map((location) => location.location_name)
                ),
              ],
          department: isEditing
            ? [
                ...new Set(
                  editoverAllAppraiseeData.flatMap(
                    (data) => data.leveldepartmentname
                  )
                ),
              ]
            : [
                ...new Set(
                  overAllAppraiseeData.flatMap(
                    (data) => data.leveldepartmentname
                  )
                ),
              ],
          grade: isEditing
            ? [
                ...new Set(
                  editoverAllAppraiseeData.flatMap((data) => data.grade)
                ),
              ]
            : [...new Set(overAllAppraiseeData?.map((data) => data.grade))],
          userid: userInfo.userid,
          employeeid: getEmployeeList.employeeId,
          individual_appraisals: isEditing ? stepData : updatedStepData,
        };
        try {
          const { code } = await CALL_API(
            isEditing
              ? `appraisal/performancecontract/${editAppraiseeData[0]?.contractid}`
              : `appraisal/performancecontract`,
            isEditing ? "patch" : "post",
            obj
          );
          if (code === STATUS_CODE.SUCCESS) {
            let successMessage = "";
            if (draftStatus === true) {
              successMessage = "Saved as Draft";
            } else if (isEditing) {
              successMessage = "Updated Successfully";
            } else {
              successMessage = "Submitted Successfully";
            }
            message.success(`Performance Contract ${successMessage}`);
            if (isEditing) {
              setEditPerformance(false);
            }
            history.push("/performancemanagement", { tabId: "2" });
            setLoading(false);
          } else {
            message.error("Something went wrong. Please try again.");
          }
        } catch (error) {
          console.error("API Submission Error:", error);
          message.error("Failed to submit the Performance Contract.");
        } finally {
          setIsSubmitting(false);
        }
      };

      submitData();
    }
  }, [isSubmitting, stepData]);

  const handlePrevious = async () => {
    if (isLastTab) {
      await handleNext();
    }
    setWeightageError("");
    const currentTabs = transformedEmployees[activeEmployeeIndex].tabs;
    const currentTabIndex = currentTabs.indexOf(activeTab);

    setEmployeeData((prevData) => ({
      ...prevData,
      [`${activeEmployeeIndex}-${activeTab}`]: form.getFieldsValue(),
    }));

    if (currentTabIndex > 0) {
      setActiveTab(currentTabs[currentTabIndex - 1]);
    } else if (activeEmployeeIndex > 0) {
      setActiveEmployeeIndex((prev) => prev - 1);
      setActiveTab(
        transformedEmployees[activeEmployeeIndex - 1].tabs[
          transformedEmployees[activeEmployeeIndex - 1].tabs.length - 1
        ]
      );
    }
  };

  const columnsKeyResponsibilities = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Target objectives",
      dataIndex: "targetobjective",
      key: "targetobjective",
      render: (_, record) => (
        <Form.Item
          name={[`targetObjective${activeTab}`, record.sno, "targetobjective"]}
          rules={[{ required: true, message: "Please enter target objective" }]}
        >
          <Input placeholder="Enter..." />
        </Form.Item>
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedoutcomes",
      key: "expectedoutcomes",
      render: (_, record) => (
        <Form.Item
          name={[
            `expectedoutcomes${activeTab}`,
            record.sno,
            "expectedoutcomes",
          ]}
          rules={[
            { required: true, message: "Please enter expected outcomes" },
          ]}
        >
          <Input placeholder="Enter..." />
        </Form.Item>
      ),
    },
    {
      title: "Target Date",
      dataIndex: "targetdate",
      key: "targetdate",
      render: (_, record) => (
        <Form.Item
          name={[`targetdate${activeTab}`, record.sno, "targetdate"]}
          rules={[{ required: true, message: "Please select target date" }]}
        >
          <DatePicker placeholder="Enter..." format="DD-MM-YYYY" />
        </Form.Item>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          style={{ background: "transparent", padding: 0 }}
          icon={
            <DeleteOutlined
              style={{ color: "red", background: "transparent" }}
            />
          }
          onClick={() => handleDeleteRow(record.sno)}
          disabled={keyResponsibilitiesData?.length === 1}
        />
      ),
    },
  ];

  const [weightageError, setWeightageError] = useState("");

  const validateTotalWeightage = () => {
    const values = form.getFieldValue(`weightage${activeTab}`) || {};
    const total = Object.values(values).reduce(
      (sum, item) => sum + (parseInt(item?.weightage, 10) || 0),
      0
    );

    if (total !== 100) {
      setWeightageError("Total weightage must be exactly 100%");
      return false;
    } else {
      setWeightageError("");
      return true;
    }
  };

  const weightageColumns = [
    {
      title: "Objectives",
      dataIndex: "objectives",
      key: "objectives",
    },

    {
      title: "Weightage (%)",
      dataIndex: "weightage",
      key: "weightage",
      render: (text, record) => (
        <Form.Item
          name={[`weightage${activeTab}`, record.sno, "weightage"]}
          initialValue={text}
          rules={[
            {
              required: true,
              message: "Please enter weightage",
            },
            {
              pattern: /^\d+$/,
              message: "Only numeric values allowed",
            },
          ]}
        >
          <Input placeholder="Enter..." onChange={validateTotalWeightage} />
        </Form.Item>
      ),
    },
  ];

  const [cardHeight, setCardHeight] = useState(null);
  const cardRef = useRef(null);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (cardRef.current) {
      setTimeout(() => {
        setCardHeight(cardRef.current.clientHeight);
      }, 100);
    }
  }, [activeEmployeeIndex, activeTab, keyResponsibilitiesData]);

  useEffect(() => {
    if (cardRef.current) {
      const resizeObserver = new ResizeObserver(() => {
        setCardHeight(cardRef.current.clientHeight);
      });

      resizeObserver.observe(cardRef.current);
      return () => resizeObserver.disconnect();
    }
  }, []);

  const isFirstTab = activeEmployeeIndex === 0 && activeTab === "Primary";
  const isLastTab =
    activeEmployeeIndex === transformedEmployees?.length - 1 &&
    activeTab ===
      transformedEmployees[transformedEmployees?.length - 1]?.tabs?.slice(
        -1
      )[0];

  const lastEmployeeTabLength =
    transformedEmployees[transformedEmployees?.length - 1]?.tabs?.length || 0;

  const [isFormValid, setIsFormValid] = useState(false);

  const checkValidation = () => {
    const hasErrors = form
      .getFieldsError()
      .some(({ errors }) => errors.length > 0);

    const allFieldsFilled = form.isFieldsTouched(true) && !hasErrors;

    setIsFormValid(allFieldsFilled);
  };

  useEffect(() => {
    checkValidation();
  }, [form]);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(
      employeeData[`${activeEmployeeIndex}-${activeTab}`] || {}
    );
  }, [activeTab, activeEmployeeIndex]);

  useEffect(() => {
    form.setFieldsValue(
      keyResponsibilitiesData?.reduce((acc, item) => {
        acc[`targetObjective${activeTab}`] = {
          ...acc[`targetObjective${activeTab}`],
          [item.sno]: { targetobjective: item.targetobjective },
        };
        acc[`expectedoutcomes${activeTab}`] = {
          ...acc[`expectedoutcomes${activeTab}`],
          [item.sno]: { expectedoutcomes: item.expectedoutcomes },
        };
        acc[`targetdate${activeTab}`] = {
          ...acc[`targetdate${activeTab}`],
          [item.sno]: {
            targetdate: item.targetdate ? moment(item.targetdate) : null,
          },
        };
        return acc;
      }, {})
    );
  }, [keyResponsibilitiesData, activeTab, form]);

  useEffect(() => {
    form.setFieldsValue(
      weightageSource.reduce((acc, item) => {
        acc[`weightage${activeTab}`] = {
          ...acc[`weightage${activeTab}`],
          [item.sno]: { weightage: item.weightage },
        };
        return acc;
      }, {})
    );
  }, [weightageSource, activeTab, form]);

  return (
    <>
      <Styleddiv className="w-100">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Row
            style={{ borderBottom: "1px solid #ddd", paddingBottom: "10px" }}
          >
            <Col span={4} className="employee-count">
              Completed: {completedEmployees.length}/
              {transformedEmployees.length}
            </Col>
            <Col span={19}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="employee-name">
                  {transformedEmployees[activeEmployeeIndex]?.name}
                </div>

                <div className="employee-info" onClick={showModal}>
                  <InfoEye /> &nbsp; Employee Info
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col
              span={4}
              style={{
                overflowY: "auto",
                borderRight: "1px solid #ddd",
                padding: "10px",
                height: "calc(100vh - 360px)",
                marginBottom: "50px",
              }}
            >
              {transformedEmployees.map((emp, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px",
                    background:
                      activeEmployeeIndex === index
                        ? "rgb(243, 254, 250)"
                        : "transparent",
                    boxShadow:
                      activeEmployeeIndex === index
                        ? "0px 4px 6px rgba(0, 0, 0, 0.1)"
                        : "none",
                    borderRadius: "4px",
                    justifyContent: "space-between",
                    cursor: completedEmployees.includes(emp.name)
                      ? "pointer"
                      : "default",
                  }}
                  onClick={() => {
                    if (completedEmployees.includes(emp.name)) {
                      setActiveEmployeeIndex(index);
                      setActiveTab(emp.tabs[0]);
                    }
                  }}
                >
                  <span>{emp.name}</span>
                  {isDraft &&
                    draftAppraiseeData.some(
                      (item) => item.name === emp.name
                    ) && <CircleTick />}
                  {!isDraft && completedEmployees.includes(emp.name) && (
                    <CircleTick />
                  )}
                </div>
              ))}
            </Col>

            <Col span={20}>
              <Card ref={cardRef} style={{ margin: "10px" }}>
                <div
                  ref={scrollContainerRef}
                  style={{
                    height: "calc(100vh - 380px)",
                    overflowY: "scroll",
                  }}
                >
                  <Form
                    form={form}
                    layout="vertical"
                    initialValues={{
                      activeTab: transformedEmployees?.[0]?.tabs?.[0],
                    }}
                    onValuesChange={(_, allValues) => {
                      handleFormChange(allValues);
                      checkValidation();
                    }}
                  >
                    <Tabs
                      activeKey={activeTab}
                      onChange={(key) => {
                        if (!employeesState[activeEmployeeIndex]?.tabs[key])
                          return;
                        setEmployeeData((prevData) => ({
                          ...prevData,
                          [`${activeEmployeeIndex}-${activeTab}`]:
                            form.getFieldsValue(),
                        }));

                        setActiveTab(key);
                      }}
                      tabBarExtraContent={
                        <p className="view-job-description" onClick={showJob}>
                          View Job Description
                        </p>
                      }
                    >
                      {transformedEmployees?.[activeEmployeeIndex]?.tabs?.map(
                        (tab) => (
                          <Tabs.TabPane key={tab} tab={tab}>
                            <div className="heading-text">
                              <b>
                                Key Responsibilities / Target for the Upcoming
                                Appraisal Period
                              </b>
                            </div>
                            <Table
                              columns={columnsKeyResponsibilities}
                              dataSource={keyResponsibilitiesData}
                              pagination={false}
                              footer={() => (
                                <div>
                                  <Button
                                    style={{ border: "none" }}
                                    onClick={handleAddRow}
                                    disabled={
                                      keyResponsibilitiesData?.length >= 10
                                    }
                                  >
                                    <span
                                      style={{ textDecoration: "underline" }}
                                    >
                                      + Add another (Max 10 rows)
                                    </span>
                                  </Button>
                                </div>
                              )}
                            />
                            <div className="heading-text">
                              <b>Technical Assessment</b>
                            </div>
                            <Table
                              columns={weightageColumns}
                              dataSource={weightageSource}
                              pagination={false}
                            />
                            {weightageError && (
                              <div style={{ color: "red", marginTop: 8 }}>
                                {weightageError}
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                marginTop: "20px",
                                marginBottom: "20px",
                                gap: "10px",
                              }}
                            >
                              {!isFirstTab && (
                                <span
                                  className="prev-arrow"
                                  onClick={handlePrevious}
                                >
                                  &lt; Previous
                                </span>
                              )}

                              {!isLastTab && (
                                <span
                                  className="next-arrow"
                                  onClick={() => {
                                    handleNext();
                                    setIsFormValid(false);
                                    scrollContainerRef.current?.scrollTo({
                                      top: 0,
                                      behavior: "smooth",
                                    });
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "16px",
                                  }}
                                >
                                  Next &gt;
                                </span>
                              )}
                            </div>
                          </Tabs.TabPane>
                        )
                      )}
                    </Tabs>
                  </Form>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
        <StyledModal
          width={500}
          height={220}
          open={isCancelModal}
          onCancel={handleModalCancel}
          footer={[
            <div
              key="footer-buttons"
              style={{ display: "flex", justifyContent: "center", gap: "10px" }}
            >
              <Button
                className="cancel-modal-button"
                key="cancel"
                onClick={handleModalCancel}
              >
                Cancel
              </Button>
              ,
              <Button
                key="discard"
                onClick={handleDiscard}
                className="discard-modal-button"
              >
                Discard
              </Button>
              ,
              <Button
                key="saveExit"
                type="primary"
                className="save-modal-button"
                onClick={() => {
                  handleSaveAndExit();
                  setDraftStatus(true);
                }}
              >
                Save & Exit
              </Button>
            </div>,
          ]}
        >
          <CircleWarning className="circle-warning-container" />
          <br />
          <p className="modal-text">
            You haven't completed the performance setup yet. Do you want to save
            the progress before leaving?
          </p>
        </StyledModal>
        <StyledModal
          width={210}
          open={isCreatedModalVisible}
          onCancel={handleCreatedModalClose}
          footer={false}
          closable={false}
          bodyStyle={{
            height: "100px",
          }}
          style={{ marginTop: "90px" }}
        >
          <div className="tick-created">
            <Tick />
            <p className="created-text">Created</p>
          </div>
        </StyledModal>
        <StyledModal
          title={<div className="modal-title">Job Description</div>}
          open={isJobDescription}
          onCancel={handleCancel}
          width={1000}
          style={{
            maxHeight: "700px",
            overflowY: "auto",
            paddingBottom: "15px",
            borderRadius: "8px",
            marginTop: "-70px",
          }}
          footer={null}
        >
          <div>
            <p className="role-title">Role – Accountant</p>
            <StyledSpan>
              <p>
                This role requires strong analytical skills, proficiency in
                accounting software, and a solid understanding of accounting
                principles.
              </p>
              Key Responsibilities:
              <ul>
                <li>
                  Record and manage daily financial transactions, including
                  accounts payable, accounts receivable, and general ledger
                  entries.
                </li>
                <li>
                  Prepare and analyze financial statements, including balance
                  sheets, income statements, and cash flow statements.
                </li>
                <li>Perform month-end and year-end closing processes.</li>
                <li>
                  Ensure compliance with local, state, and federal tax
                  regulations, and assist with tax filings.
                </li>
                <li>
                  Conduct regular audits to ensure accuracy in financial records
                  and identify discrepancies.
                </li>
                <li>Reconcile bank statements and monitor cash flow.</li>
                <li>Assist in budget preparation and financial forecasting.</li>
                <li>
                  Support internal and external audits by providing required
                  documentation and explanations.
                </li>
                <li>Maintain and update financial policies and procedures.</li>
                <li>
                  Collaborate with other departments to provide financial
                  insights and guidance.
                </li>
              </ul>
              Qualifications and Skills:
              <ul>
                <li>
                  Bachelor’s degree in Accounting, Finance, or a related field.
                </li>
                <li>
                  Professional certifications such as CPA, ACCA, or equivalent
                  are a plus.
                </li>
                <li>
                  Proven experience as an accountant or in a similar role.
                </li>
                <li>
                  Proficiency in accounting software (e.g., QuickBooks, SAP, or
                  Tally).
                </li>
                <li>
                  Strong knowledge of accounting principles, standards, and
                  regulations.
                </li>
                <li>Excellent analytical and problem-solving skills.</li>
                <li>Attention to detail and high level of accuracy.</li>
                <li>Strong organizational and time management skills.</li>
                <li>Effective communication and teamwork abilities.</li>
              </ul>
            </StyledSpan>
          </div>
        </StyledModal>
        <StyledModal
          title="Employee Info"
          open={isModalVisible}
          onCancel={handleCancelModal}
          size="lg"
          width={1300}
          bodyStyle={{ height: 550, overflowY: "auto" }}
          style={{
            top: 10,
            maxHeight: "700px",
            overflowY: "auto",
            borderRadius: "10px 10px !important",
          }}
          visible={isModalVisible}
          footer={null}
        >
          <Card
            style={{
              background: "#F3FEFA",
              width: "1237",
              height: "105",
              border: "1px solid rgba(226, 226, 232, 1)",
            }}
            className="card-container"
          >
            <Row gutter={40}>
              <Col xs={2}>
                <div
                  style={{
                    width: "73px",
                    height: "73px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: " #C2FAE5", // Background for initials
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  {selectedEmployee?.profileurl ? (
                    <img
                      src={selectedEmployee?.profileurl}
                      alt="profile-image"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <span>
                      {selectedEmployee?.fullname
                        ? selectedEmployee?.fullname?.charAt(0).toUpperCase()
                        : "?"}
                    </span>
                  )}
                </div>
              </Col>
              <Col xs={6}>
                <div>
                  <p
                    style={{
                      fontSize: "18px",
                      fontWeight: "500",
                      margin: "0",
                    }}
                  >
                    {selectedEmployee?.fullname || "-"} (
                    {selectedEmployee?.grade || "-"})
                    {/* {findUser?.fullname || "-"} ({findUser?.grade || "-"}) */}
                  </p>
                  <StyledSpan
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      margin: "0",
                    }}
                  >
                    {selectedEmployee?.designation || "-"}
                    {/* {findUser?.designation || "-"} */}
                  </StyledSpan>
                </div>
              </Col>
              <Col xs={6}>
                <div className="details1">
                  <p>
                    Employee ID:{" "}
                    <StyledSpan>
                      {selectedEmployee?.employeeid || "-"}
                      {/* {findUser?.employeeid || "-"} */}
                    </StyledSpan>{" "}
                    <br />
                    Managing office:{" "}
                    <StyledSpan>
                      {selectedEmployee?.managingoffice || "-"}
                      {/* {findUser?.managingoffice || "-"} */}
                    </StyledSpan>{" "}
                    <br />
                    Location:{" "}
                    <StyledSpan>
                      {filterLevelLocationName?.location_name || "-"}
                      {/* {findUser?.country || "-"} */}
                    </StyledSpan>
                  </p>
                </div>
              </Col>
              <Col xs={6} style={{ paddingLeft: "100px" }}>
                <div className="details2">
                  <p>
                    Department:{" "}
                    <StyledSpan>
                      {selectedEmployee?.leveldepartmentname || "-"}
                      {/* {findUser?.jobtitle || "-"} */}
                    </StyledSpan>{" "}
                    <br />
                    Hired Date:{" "}
                    <StyledSpan>
                      {selectedEmployee?.hireddate || "-"}
                      {/* {findUser?.hireddate || "-"} */}
                    </StyledSpan>{" "}
                    <br />
                    Expertise:{" "}
                    <StyledSpan>
                      {selectedEmployee?.expertise || "---"}
                      {/* {findUser?.expertise || "---"} */}
                    </StyledSpan>
                  </p>
                </div>
              </Col>
            </Row>
          </Card>
          <br />
          <div>
            <Sectiontitle>Work Information</Sectiontitle>
          </div>
          <Row gutter={40}>
            <Col xs={5}>
              <div>
                <p style={{ lineHeight: "2.5", margin: "0" }}>
                  <StyledSpan>
                    Contracting Company (s)
                    <br />
                    Target Changeability
                    <br />
                    Last Promotion Level
                  </StyledSpan>
                </p>
              </div>
            </Col>
            <Col xs={6}>
              <div>
                <p style={{ lineHeight: "2.5", margin: "0" }}>
                  {/* {findUser?.companyname || "---"} <br />
                      {findUser?.targetchargeability || "---"} <br />
                      {findUser?.lastpromotion || "---"} */}
                  {selectedEmployee?.companyname || "---"}
                  <br /> {selectedEmployee?.targetchargeability || "---"}
                  <br /> {selectedEmployee?.lastpromotionlevel || "---"}
                </p>
              </div>
            </Col>
            <Col xs={5} style={{ paddingLeft: "60px" }}>
              <div>
                <p style={{ lineHeight: "2.5", margin: "0" }}>
                  <StyledSpan>
                    Target Charge out rate
                    <br />
                    Last Promotion Date
                    <br />
                    No. of Dependents
                  </StyledSpan>
                </p>
              </div>
            </Col>
            <Col xs={7}>
              <div>
                <p style={{ lineHeight: "2.5", margin: "0" }}>
                  {/* {findUser?.chargeoutrate || "---"} <br />
                      {findUser?.lastpromotionlevel || "---"} <br />
                      {findUser?.dependent || "---"} */}
                  {selectedEmployee?.chargeoutrate || "---"} <br />{" "}
                  {selectedEmployee?.lastpromotion || "---"}
                  <br /> {selectedEmployee?.dependent || "---"}
                </p>
              </div>
            </Col>
          </Row>
          <br />
          <div>
            <Sectiontitle>Personal Information</Sectiontitle>
          </div>
          <Row gutter={40}>
            <Col xs={5}>
              <div>
                <p style={{ lineHeight: "2.5", margin: "0" }}>
                  <StyledSpan>
                    Date Of Birth
                    <br />
                    Salutation
                    <br />
                    Gender
                    <br />
                    Email ID
                    <br />
                    National ID / Passport No
                    <br />
                    Emergency Contact Name
                    <br />
                    Emergency Contact Number
                  </StyledSpan>
                </p>
              </div>
            </Col>
            <Col xs={6}>
              <div>
                <p style={{ lineHeight: "2.5", margin: "0" }}>
                  {/* {findUser?.companyname || "---"} <br />
                      {findUser?.targetchargeability || "---"} <br />
                      {findUser?.lastpromotion || "---"} */}
                  {selectedEmployee?.dateofbirth
                    ? moment(selectedEmployee.dateofbirth).format("DD-MM-YYYY")
                    : "---"}
                  <br />
                  {selectedEmployee?.salutation || "---"}
                  <br />
                  {selectedEmployee?.gender || "---"}
                  <br />
                  {selectedEmployee?.userid || "---"}
                  <br />
                  {selectedEmployee?.national_id || "---"}
                  <br />
                  {selectedEmployee?.emergencycontactname || "---"}
                  <br />
                  {selectedEmployee?.emergencycontactnumber || "---"}
                </p>
              </div>
            </Col>
            <Col xs={5} style={{ paddingLeft: "60px" }}>
              <div>
                <p style={{ lineHeight: "2.5", margin: "0" }}>
                  <StyledSpan>
                    Professional Since
                    <br />
                    Marital Status
                    <br />
                    Phone Number
                    <br />
                    Postal Address
                    <br />
                    Greetings <br /> Emergency Contact Email
                  </StyledSpan>
                </p>
              </div>
            </Col>
            <Col xs={7}>
              <div>
                <p style={{ lineHeight: "2.5", margin: "0" }}>
                  {/* {findUser?.chargeoutrate || "---"} <br />
                      {findUser?.lastpromotionlevel || "---"} <br />
                      {findUser?.dependent || "---"} */}
                  {selectedEmployee?.professionalsince || "---"}
                  <br /> {selectedEmployee?.maritalstatus || "---"} <br />{" "}
                  {selectedEmployee?.phoneno || "---"} <br />
                  {selectedEmployee?.postaladdress || "---"}
                  <br />
                  {selectedEmployee?.greetings || "---"} <br />
                  {selectedEmployee?.userid || "---"}
                </p>
              </div>
            </Col>
          </Row>
          <Tabs
            defaultActiveKey="1"
            items={appraisalitems}
            onChange={onChangeEmp}
            className="employee-info-tabs"
          />
        </StyledModal>
        <div
          style={{
            position: "sticky",
            bottom: 0,
            width: "100%",
            background: "#fff",
            boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
            padding: "10px 20px",
            display: "flex",
            justifyContent: "end",
            gap: "10px",
            margin: "auto",
          }}
        >
          <Button
            className="cancel-previous-button"
            onClick={() => {
              // if (isEditing && !isDraft) {
              setEditPerformance(false);
              setIsDraft(false);
              history.push(`/performancemanagement`, { tabId: 2 });
              // } else {
              //   showCancelModal();
              // }
            }}
          >
            Cancel
          </Button>

          {((!isEditing && !isDraft) || isDraft) && (
            <Button
              onClick={() => setStep(0)}
              className="cancel-previous-button"
            >
              Previous
            </Button>
          )}
          <Button
            type="primary"
            disabled={
              isDraft
                ? editAppraiseeData?.length !==
                    draftAppraiseeData?.length - 1 && !isLastTab
                : !isLastTab && !isEditing
            }
            loading={loading}
            onClick={async () => {
              try {
                await form.validateFields();
                handleSubmit();
              } catch (error) {
                console.error("Validation failed:", error);
                message.error("Please fill in all required fields.");
              }
            }}
          >
            {(!isEditing && !isDraft) || isDraft ? "Create" : "Save Changes"}
          </Button>
        </div>
      </Styleddiv>
    </>
  );
};

const mapStateToProps = (state) => ({
  supervisorList: getSupervisorList(state),
  // userInfo: getUserInfo(state),
});

// export default CreatingPerformance;
export default connect(mapStateToProps, null)(CreatingPerformance);
